<template lang='pug' src='./app.pug'></template>

<script>
// components
import Loader from 'components/loader/loader'
import NavDesktop from 'components/Nav/Nav'
import NavMobile from 'components/Nav/Nav-Mobile/Nav-Mobile'
import NavTrigger from 'components/custom/custom-nav-trigger/custom-nav-trigger'
import FooterDesktop from 'components/Footer/Footer'
import FooterMobile from 'components/Footer-Mobile/Footer-Mobile'
import Modal from 'components/custom/custom-modal-text/custom-modal-text'
import Icon from 'components/icon/icon'
import BaseBaseAccess from 'components/base-access/index'

export default {
  data () {
    return {
      elementVisible: true
    }
  },
  created () {
    this.$store.dispatch('GET_PAGES')
    this.$store.dispatch('VIEW_NAV', false)
    this.$store.dispatch('VIEW_BODY', false)
    this.$store.dispatch('VIEW_TYPES', 0)
    this.$store.dispatch('VIEW_SHOWMODAL', false)
    this.$store.dispatch('VIEW_MODALCONTENT', false)
    this.$store.dispatch('LOADING', true)
    setTimeout(() => {
      this.elementVisible = false
    }, 9000)
  },
  computed: {
    props () {
      return this.$store.state
    },
    props2 () {
      return this.$store.state.pages['nav']
    }
  },
  components: {
    Loader,
    NavDesktop,
    NavMobile,
    NavTrigger,
    FooterDesktop,
    FooterMobile,
    Modal,
    Icon,
    BaseBaseAccess
  },
  name: 'app'
}
</script>

<-- styles have been moved to main.sass file -->
<style src='../main.sass' lang='sass'></style>



// WEBPACK FOOTER //
// app.vue?3f86fb33